import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplets, Wind, Shield, CheckCircle2, Clock, Leaf, Brush, SprayCan, Plane, Armchair, Cigarette, UtensilsCrossed, Droplet, Biohazard, Eraser, FileText } from 'lucide-react';
export function CleaningServices() {
  const addOns = [{
    icon: Brush,
    text: 'Carpet Extraction'
  }, {
    icon: SprayCan,
    text: 'Lavatory Deep Sanitation'
  }, {
    icon: Plane,
    text: 'Cockpit Detail'
  }, {
    icon: Armchair,
    text: 'Leather Conditioning'
  }, {
    icon: Cigarette,
    text: 'Cigarette and Odor Removal'
  }, {
    icon: UtensilsCrossed,
    text: 'Galley Deep Clean'
  }, {
    icon: Droplet,
    text: 'Seat Shampoo'
  }, {
    icon: Biohazard,
    text: 'Mold and Biohazard Cleaning'
  }, {
    icon: Eraser,
    text: 'Seat Stain Removal'
  }, {
    icon: FileText,
    text: 'Custom Quote'
  }];
  return <section className="py-24 bg-navy relative border-b border-white/5" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <span className="text-gold text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-17">
            Aircraft Cleaning
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-18">
            Let Us Make Your Aircraft Look Its Best.
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-19">
            Professional aircraft cleaning, cabin restoration and exterior
            detailing services. Airline and MRO approved.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-16" data-id="element-20">
          {[{
          text: 'Airline & MRO Approved',
          icon: Shield
        }, {
          text: 'Overnight AOG Service',
          icon: Clock
        }, {
          text: 'Attention to Detail',
          icon: Sparkles
        }, {
          text: 'Eco-Friendly Products',
          icon: Leaf
        }].map((badge, idx) => <div key={idx} className="flex items-center text-slate-300 bg-navy-light px-5 py-2 rounded-full border border-white/5" data-id="element-21">
              <badge.icon className="w-4 h-4 text-gold mr-2" data-id="element-22" />
              <span className="text-sm font-medium uppercase tracking-wider" data-id="element-23">
                {badge.text}
              </span>
            </div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-24">
          {/* Interior */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-light rounded-2xl p-8 border border-white/5" data-id="element-25">
            <div className="flex items-center mb-6" data-id="element-26">
              <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center mr-4 border border-gold/20" data-id="element-27">
                <Sparkles className="w-5 h-5 text-gold" data-id="element-28" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-white uppercase" data-id="element-29">
                Interior Cleaning Services
              </h3>
            </div>

            <div className="space-y-6" data-id="element-30">
              <div data-id="element-31">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-32">
                  Private Aircraft Interior Cleaning
                </h4>
                <div className="bg-navy rounded-xl p-5 border border-white/5 space-y-4" data-id="element-33">
                  <div data-id="element-34">
                    <span className="text-white font-medium block mb-2" data-id="element-35">
                      Light Cabin Cleaning
                    </span>
                    <p className="text-slate-400 text-sm" data-id="element-36">
                      Vacuuming, Wipe-down, Trash removal, Windows, Lavatories
                    </p>
                  </div>
                  <div className="border-t border-white/10 pt-4" data-id="element-37">
                    <span className="text-white font-medium block mb-2" data-id="element-38">
                      Deep Detail
                    </span>
                    <p className="text-slate-400 text-sm" data-id="element-39">
                      Leather conditioning, Carpet shampoo, Deep sanitation, Bin
                      cleaning, Galley and lav detail, Galley UV disinfecting,
                      Stain removal
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-40">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-41">
                  A320 Family Interior Services
                </h4>
                <ul className="space-y-2" data-id="element-42">
                  {['Transit/Turn Cleaning', 'Overnight Interior Cleaning', 'Deep Interior Restoration'].map((item, i) => <li key={i} className="flex items-center text-slate-300 text-sm" data-id="element-43">
                      <CheckCircle2 className="w-4 h-4 text-gold mr-3" data-id="element-44" /> {item}
                    </li>)}
                </ul>
              </div>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 flex items-start" data-id="element-45">
                <Clock className="w-5 h-5 text-gold mr-3 shrink-0 mt-0.5" data-id="element-46" />
                <div data-id="element-47">
                  <span className="text-white font-bold block text-sm uppercase mb-1" data-id="element-48">
                    Emergency AOG Service
                  </span>
                  <p className="text-gold-light text-sm" data-id="element-49">
                    Short notice, overnight or return-to-service cleaning
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Exterior */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy-light rounded-2xl p-8 border border-white/5 flex flex-col" data-id="element-50">
            <div className="flex items-center mb-6" data-id="element-51">
              <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center mr-4 border border-gold/20" data-id="element-52">
                <Wind className="w-5 h-5 text-gold" data-id="element-53" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-white uppercase" data-id="element-54">
                Exterior Dry Wash Services
              </h3>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-55">
              <div data-id="element-56">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-57">
                  Private Aircraft Dry Wash
                </h4>
                <div className="grid grid-cols-3 gap-3" data-id="element-58">
                  {['Light Jet', 'Mid-Size Jet', 'Heavy Jet'].map((item, i) => <div key={i} className="bg-navy rounded-lg p-3 text-center border border-white/5" data-id="element-59">
                      <span className="text-slate-300 text-sm" data-id="element-60">{item}</span>
                    </div>)}
                </div>
              </div>

              <div data-id="element-61">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-62">
                  A320/A321 Exterior Dry Wash
                </h4>
                <div className="bg-navy rounded-xl p-5 border border-white/5" data-id="element-63">
                  <p className="text-slate-400 text-sm mb-4" data-id="element-64">
                    Complete exterior dry wash utilizing aviation-approved,
                    eco-friendly compounds that clean and protect the paint
                    surface without water runoff.
                  </p>
                  <ul className="space-y-2" data-id="element-65">
                    {['Fuselage cleaning', 'Wing and tail surfaces', 'Landing gear wipe-down', 'Window polishing'].map((item, i) => <li key={i} className="flex items-center text-slate-300 text-sm" data-id="element-66">
                        <CheckCircle2 className="w-4 h-4 text-gold mr-3" data-id="element-67" />{' '}
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Add-ons */}
        <div data-id="element-68">
          <h4 className="text-center text-white font-heading font-bold text-2xl uppercase mb-8" data-id="element-69">
            Popular Add-On Services
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-70">
            {addOns.map((item, idx) => {
            const Icon = item.icon;
            return <div key={idx} className="bg-navy-light border border-white/5 rounded-xl p-4 text-center hover:border-gold/30 transition-colors group" data-id="element-71">
                  <Icon className="w-5 h-5 text-gold mx-auto mb-2 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-72" />
                  <span className="text-slate-300 text-xs uppercase tracking-wide font-medium" data-id="element-73">
                    {item.text}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}